import {fromJson} from "../utils/helper.js";


class TipoDocumentoModel {


    constructor() {

        this.id = null;
        this.tipo_documento_id = null;
        this.tipo_processo_id = null;

    }


    static fromJson(object) {
        return fromJson((new TipoDocumentoModel()), object);
    }

}

export default TipoDocumentoModel;
